export default __webpack_public_path__ + "static/media/icon-pathwayreport_motivation.2e24daeb.png";